module.exports = __webpack_public_path__ + "img/custom.6fbb1531.png";